import React, { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Lock, ArrowLeft } from "lucide-react";
import { usePartner } from "../context/PartnerContext";
import { BrandLogo } from "../components/BrandLogo";

export default function PartnerLogin() {
  const { login, partner } = usePartner();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  if (partner && partner.id) return <Navigate to="/partner" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    const res = await login(email.trim(), password);
    setBusy(false);
    if (res.ok) {
      if (res.partner.estado !== "aprobado") {
        setErr("Tu cuenta aún está pendiente de aprobación. Te avisaremos por email.");
        return;
      }
      nav("/partner");
    } else setErr(res.error);
  };

  return (
    <div className="min-h-screen grid md:grid-cols-5" style={{ background: "var(--bg-soft)" }}>
      <div className="md:col-span-3 hidden md:flex flex-col justify-between p-12 relative overflow-hidden" style={{ background: "var(--brand-navy)" }}>
        <Link to="/" className="relative z-10">
          <BrandLogo size={44} variant="light" subline="Programa Partners" iconBg="rgba(255,255,255,0.04)"/>
        </Link>

        <div className="text-white relative z-10">
          <div className="text-[11px] uppercase tracking-[0.2em] font-bold mb-3" style={{ color: "var(--brand-accent)" }}>Tu panel partner</div>
          <h1 className="text-4xl font-extrabold tracking-tight leading-tight max-w-sm" style={{ fontFamily: "Manrope" }}>
            Comisiones, pólizas y referidos en un solo lugar.
          </h1>
          <p className="mt-4 opacity-75 max-w-sm">
            Accede al panel para referir comunidades, monitorear comisiones acumuladas y ver el estado de cada referencia en vivo.
          </p>
        </div>
        <div className="text-white/50 text-xs relative z-10">© {new Date().getFullYear()} Mi Comunidad Segura SpA</div>
        <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full opacity-20" style={{ background: "var(--brand-accent)" }}></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full opacity-10" style={{ background: "white" }}></div>
      </div>

      <div className="md:col-span-2 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="partner-login-form">
          <div className="flex items-center gap-2 mb-8">
            <div className="w-10 h-10 rounded-md flex items-center justify-center" style={{ background: "var(--brand-navy)" }}>
              <Lock size={18} color="white" />
            </div>
            <h2 className="text-2xl font-bold tracking-tight" style={{ fontFamily: "Manrope" }}>Acceso partners</h2>
          </div>

          <div className="space-y-4">
            <div>
              <label className="field-label">Email</label>
              <input className="field-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="partner-login-email"/>
            </div>
            <div>
              <label className="field-label">Contraseña</label>
              <input className="field-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="partner-login-password"/>
            </div>
          </div>

          {err && <div className="mt-4 p-3 rounded-md text-sm border" style={{ borderColor: "rgba(211,47,47,0.25)", background: "rgba(211,47,47,0.05)", color: "#9a1919" }} data-testid="partner-login-error">{err}</div>}

          <button type="submit" className="btn-primary w-full justify-center mt-6" disabled={busy} data-testid="partner-login-submit">
            {busy ? "Ingresando..." : "Ingresar"}
          </button>

          <div className="mt-6 text-center text-sm space-y-2">
            <div>
              ¿No tienes cuenta?{" "}
              <Link to="/partner/register" className="font-semibold nav-link" style={{ color: "var(--brand-accent)" }} data-testid="link-partner-register">
                Únete al programa
              </Link>
            </div>
            <Link to="/" className="inline-flex items-center gap-1 nav-link" style={{ color: "var(--text-muted)" }}>
              <ArrowLeft size={13}/> Volver al sitio
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
